import React from 'react'
import { Route, Switch } from 'react-router'
import GeneralSettings from './GeneralSettings'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={GeneralSettings} />
    </Switch>
)

export default Components
